import settings from '@/settings'

let listaUsuarios = (pagination, filter, headers) => {
  return fetch(`${settings.apetrusApi}/clientes/usuarios/?page=${pagination.page}&ativo=${filter.ativo}&verificado=${filter.verificado}&clube=${filter.clube}`, {
    method: 'GET',
    mode: 'cors',
    cache: 'default',
    headers: headers
  })
}

let desativarCliente = (id, headers) => {
  return fetch(`${settings.apetrusApi}/clientes/desativar/?id_cliente=${id}`, {
    method: 'DELETE',
    mode: 'cors',
    cache: 'default',
    headers: headers
  })
}

let ativarCliente = (id, headers) => {
  return fetch(`${settings.apetrusApi}/clientes/ativar/?id_cliente=${id}`, {
    method: 'PUT',
    mode: 'cors',
    cache: 'default',
    headers: headers
  })
}

let getEmpresas = (pagination, filters, headers) => {
  let url = `${settings.apetrusApi}/empresas/todas/?page=${pagination.page}`
  Object.keys(filters).forEach(filter => {
    url = `${url}&${filter}=${filters[filter]}`
  })

  return fetch(url, {
    method: 'GET',
    mode: 'cors',
    cache: 'default',
    headers: headers
  })
}

let getPostos = (pagination, filters, headers) => {
  let url = `${settings.apetrusApi}/postos/all/?page=${pagination.page}`
  Object.keys(filters).forEach(filter => {
    url = `${url}&${filter}=${filters[filter]}`
  })

  return fetch(url, {
    method: 'GET',
    mode: 'cors',
    cache: 'default',
    headers: headers
  })
}

let updatePosto = (data, cnpj, headers) => {
  return fetch(`${settings.apetrusApi}/postos/${cnpj}/`, {
    method: 'PATCH',
    mode: 'cors',
    cache: 'default',
    body: JSON.stringify(data),
    headers: headers
  })
}

let infoPosto = (cnpj, headers) => {
  return fetch(`${settings.apetrusApi}/postos/pegarporadmin/?cnpj=${cnpj}`, {
    method: 'GET',
    mode: 'cors',
    cache: 'default',
    headers: headers
  })
}

let verificarEmail = (headers) => {
  return fetch(`${settings.apetrusApi}/administradores/verificaremail/`, {
    method: 'GET',
    mode: 'cors',
    cache: 'default',
    headers: headers
  })
}

let getInstituicoes = (pagination, filters, headers) => {
  return fetch(`${settings.apetrusApi}/instituicoes/all/?page=${pagination.page}`, {
    method: 'GET',
    mode: 'cors',
    cache: 'default',
    headers: headers
  })
}

let cadastrarpin = (pin, headers) => {
  return fetch(`${settings.apetrusApi}/administradores/cadastrarpin/`, {
    method: 'PUT',
    body: JSON.stringify({
      pin: pin
    }),
    mode: 'cors',
    headers: headers
  })
}

let autenticarpin = (pin, headers) => {
  return fetch(`${settings.apetrusApi}/administradores/autenticarpin/`, {
    method: 'POST',
    body: JSON.stringify({
      pin: pin
    }),
    mode: 'cors',
    headers: headers
  })
}

// enviar um email para todos os clientes apetrus
let enviaremail = (mail, headers) => {
  return fetch(`${settings.apetrusApi}/pessoas/emailforallusers/`, {
    method: 'post',
    body: JSON.stringify(mail),
    mode: 'cors',
    headers: headers
  })
}

const atualizarPessoa = (data, headers) => {
  return fetch(`${settings.apetrusApi}/administradores/atualizarpessoa/${data.id_pessoa}/`, {
    method: 'PUT',
    body: JSON.stringify(data),
    mode: 'cors',
    headers: headers
  })
}

const pegarNovosContratos = (headers) => {
  return fetch(`${settings.apetrusApi}/administradores/novoscontratos/`, {
    method: 'GET',
    mode: 'cors',
    cache: 'default',
    headers: headers
  })
}

const marcarComoLido = (data, headers) => {
  return fetch(`${settings.apetrusApi}/administradores/novoscontratos/?`, {
    method: 'PUT',
    body: JSON.stringify(data),
    mode: 'cors',
    headers: headers
  })
}

const meioRecebimentoApetrus = (headers, data, method) => {
  /*
    * method GET pegar os meios de recebimentos da apetrus
    * method POST cadastrar um meio de recebimento
    * method DELETE Apagar um meio de recebimetno
  */
  const request = {
    method: method,
    mode: 'cors',
    headers: headers
  }
  if (method === 'GET') request.cache = 'default'
  else request.body = JSON.stringify(data)
  return fetch(`${settings.apetrusApi}/administradores/meioderecebimento/`, request)
}

let transferirSaldo = (headers, payload) => {
  return fetch(`${settings.apetrusApi}/administradores/transferircredito/`, {
      method: 'POST',
      body: JSON.stringify({ is_posto: payload.is_posto, cpf_receptor: payload.cpf_receptor, valor_pago: payload.valor_pago, cnpj_receptor: payload.cnpj_receptor }),
      mode: 'cors',
      headers: headers
    })
}

const pegarHistoricoDaCarteiraVirtualAdm = (headers, data) => {
  let url = `${settings.apetrusApi}/administradores/historicodacarteiravirtual/`
  if (data) {
    Object.keys(data).forEach((item) => {
      url = `${url}${url[url.length - 1] === '/' ? '?' : '&'}${item}=${
        data[item]
      }`
    })
  }
  return fetch(url, {
    method: 'GET',
    mode: 'cors',
    cache: 'default',
    headers: headers
  })
}

export default {
  listaUsuarios,
  desativarCliente,
  ativarCliente,
  getPostos,
  getEmpresas,
  updatePosto,
  infoPosto,
  verificarEmail,
  getInstituicoes,
  cadastrarpin,
  autenticarpin,
  enviaremail,
  atualizarPessoa,
  pegarNovosContratos,
  marcarComoLido,
  meioRecebimentoApetrus,
  transferirSaldo,
  pegarHistoricoDaCarteiraVirtualAdm
}
